import { render, staticRenderFns } from "./DirectLinkForm.vue?vue&type=template&id=22439136&scoped=true"
import script from "./DirectLinkForm.vue?vue&type=script&lang=js"
export * from "./DirectLinkForm.vue?vue&type=script&lang=js"
import style0 from "./DirectLinkForm.vue?vue&type=style&index=0&id=22439136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22439136",
  null
  
)

export default component.exports